import pageNow from '../utils/pageNow';

const isFunction = function (func) {
    return typeof func === 'function'
};

const isString = function (string) {
    return typeof string === 'string';
};

const isArray = function (arr) {
    return Object.prototype.toString.call(arr) === '[object Array]';
};

const routes = [];

const router = {
    /**
     * @param {string|array} route
     * @param {function} callback
     * @returns {router}
     */
    add (route, callback) {
        if (!isFunction(callback)) {
            throw new Error("'callback' parameter must be a function");
        }

        if (!isString(route) && !isArray(route)) {
            throw new Error("'route' parameter must be either a string or an array");
        }

        if (isString(route)) {
            routes.push({
                callback,
                path: route
            });
        }

        if (isArray(route)) {
            route.forEach((route) => {
                routes.push({
                    callback,
                    path: route
                })
            });
        }

        return this;
    },
    /**
     * @returns {router}
     */
    run() {
        routes.forEach(function (route) {
            if (route.path === 'all' || pageNow.is(route.path)) {
                route.callback();
            }
        });

        return this;
    }
};

export default router;


// WEBPACK FOOTER //
// ./src/js/modules/domRouter.js